import { render, staticRenderFns } from "./NewTableResource.vue?vue&type=template&id=338bece0&scoped=true"
import script from "./NewTableResource.vue?vue&type=script&lang=ts"
export * from "./NewTableResource.vue?vue&type=script&lang=ts"
import style0 from "./NewTableResource.vue?vue&type=style&index=0&id=338bece0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338bece0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338bece0')) {
      api.createRecord('338bece0', component.options)
    } else {
      api.reload('338bece0', component.options)
    }
    module.hot.accept("./NewTableResource.vue?vue&type=template&id=338bece0&scoped=true", function () {
      api.rerender('338bece0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v2/table/NewTableResource.vue"
export default component.exports